import produce from 'immer';

import {
  HTML_FORM_IMAGE_DELETE_FAILURE,
  HTML_FORM_IMAGE_LIST_FETCH_FAILURE,
  HTML_FORM_IMAGE_LIST_FETCH_SUCCESS,
  HTML_FORM_IMAGES_CREATE_FAILURE,
  HTML_FORM_IMAGES_EDIT_FAILURE,
  HTML_FORM_IMAGES_EDIT_SUCCESS,
  HTML_FORM_IMAGES_FETCH_FAILURE,
  HTML_FORM_IMAGES_FETCH_SUCCESS,
} from '@actions/htmlFormImage';

const initialState: IHTMLFormImageStore = {
  currentHtmlFormImage: null,
  htmlFormImages: null,
  error: null,
};

export default (state: IHTMLFormImageStore = initialState, action: any) =>
  produce(state, (draftState: IHTMLFormImageStore) => {
    switch (action.type) {
      case HTML_FORM_IMAGES_EDIT_SUCCESS:
      case HTML_FORM_IMAGES_FETCH_SUCCESS:
        draftState.currentHtmlFormImage = action.response;
        draftState.error = null;

        return;

      case HTML_FORM_IMAGES_EDIT_FAILURE:
      case HTML_FORM_IMAGES_CREATE_FAILURE:
      case HTML_FORM_IMAGES_FETCH_FAILURE:
        draftState.currentHtmlFormImage = null;
        draftState.error = action.error;

        return;

      case HTML_FORM_IMAGE_DELETE_FAILURE:
        draftState.error = action.error;

        return;

      case HTML_FORM_IMAGE_LIST_FETCH_FAILURE:
        draftState.htmlFormImages = null;
        draftState.error = action.error;

        return;

      case HTML_FORM_IMAGE_LIST_FETCH_SUCCESS:
        draftState.htmlFormImages = action.response;
        draftState.error = null;

        return;
    }
  });
